import {commerceCountryList, type CommerceCountry} from './allCountries';

// Stripe supported countries extracted from:
// https://stripe.com/global
const STRIPE_SUPPORTED_COUNTRIES = [
  {name: 'Australia', code: 'AU'},
  {name: 'Austria', code: 'AT'},
  {name: 'Belgium', code: 'BE'},
  {name: 'Bulgaria', code: 'BG'},
  {name: 'Brazil', code: 'BR'},
  {name: 'Canada', code: 'CA'},
  {name: 'Croatia', code: 'HR'},
  {name: 'Cyprus', code: 'CY'},
  {name: 'Czech Republic', code: 'CZ'},
  {name: 'Denmark', code: 'DK'},
  {name: 'Estonia', code: 'EE'},
  {name: 'Finland', code: 'FI'},
  {name: 'France', code: 'FR'},
  {name: 'Germany', code: 'DE'},
  {name: 'Gibraltar', code: 'GI'},
  {name: 'Greece', code: 'GR'},
  {name: 'Hong Kong', code: 'HK'},
  {name: 'Hungary', code: 'HU'},
  {name: 'India', code: 'IN'},
  {name: 'Ireland', code: 'IE'},
  {name: 'Italy', code: 'IT'},
  {name: 'Japan', code: 'JP'},
  {name: 'Latvia', code: 'LV'},
  {name: 'Liechtenstein', code: 'LI'},
  {name: 'Lithuania', code: 'LT'},
  {name: 'Luxembourg', code: 'LU'},
  {name: 'Malaysia', code: 'MY'},
  {name: 'Malta', code: 'MT'},
  {name: 'Mexico', code: 'MX'},
  {name: 'Netherlands', code: 'NL'},
  {name: 'New Zealand', code: 'NZ'},
  {name: 'Norway', code: 'NO'},
  {name: 'Philippines', code: 'PH'},
  {name: 'Poland', code: 'PL'},
  {name: 'Portugal', code: 'PT'},
  {name: 'Romania', code: 'RO'},
  {name: 'Singapore', code: 'SG'},
  {name: 'Slovakia', code: 'SK'},
  {name: 'Slovenia', code: 'SI'},
  {name: 'Spain', code: 'ES'},
  {name: 'Sweden', code: 'SE'},
  {name: 'Switzerland', code: 'CH'},
  {name: 'Thailand', code: 'TH'},
  {name: 'United Arab Emirates', code: 'AE'},
  {name: 'United Kingdom', code: 'GB'},
  {name: 'United States', code: 'US'},
];

// PayPal supported countries extracted from:
// curl https://developer.paypal.com/docs/api/reference/country-codes/
const PAYPAL_SUPPORTED_COUNTRIES = [
  {name: 'Albania', code: 'AL', postalCodeRequired: false},
  {name: 'Algeria', code: 'DZ', postalCodeRequired: false},
  {name: 'Andorra', code: 'AD', postalCodeRequired: false},
  {name: 'Angola', code: 'AO', postalCodeRequired: false},
  {name: 'Anguilla', code: 'AI', postalCodeRequired: false},
  {name: 'Antigua and Barbuda', code: 'AG', postalCodeRequired: false},
  {name: 'Argentina', code: 'AR', postalCodeRequired: true},
  {name: 'Armenia', code: 'AM', postalCodeRequired: false},
  {name: 'Aruba', code: 'AW', postalCodeRequired: false},
  {name: 'Australia', code: 'AU', postalCodeRequired: true},
  {name: 'Austria', code: 'AT', postalCodeRequired: true},
  {name: 'Azerbaijan', code: 'AZ', postalCodeRequired: false},
  {name: 'Bahamas', code: 'BS', postalCodeRequired: false},
  {name: 'Bahrain', code: 'BH', postalCodeRequired: false},
  {name: 'Barbados', code: 'BB', postalCodeRequired: false},
  {name: 'Belarus', code: 'BY', postalCodeRequired: false},
  {name: 'Belgium', code: 'BE', postalCodeRequired: false},
  {name: 'Belize', code: 'BZ', postalCodeRequired: false},
  {name: 'Benin', code: 'BJ', postalCodeRequired: false},
  {name: 'Bermuda', code: 'BM', postalCodeRequired: false},
  {name: 'Bhutan', code: 'BT', postalCodeRequired: true},
  {name: 'Bolivia', code: 'BO', postalCodeRequired: false},
  {name: 'Bosnia and Herzegovina', code: 'BA', postalCodeRequired: false},
  {name: 'Botswana', code: 'BW', postalCodeRequired: false},
  {name: 'Brazil', code: 'BR', postalCodeRequired: true},
  {name: 'British Virgin Islands', code: 'VG', postalCodeRequired: false},
  {name: 'Brunei', code: 'BN', postalCodeRequired: false},
  {name: 'Bulgaria', code: 'BG', postalCodeRequired: false},
  {name: 'Burkina Faso', code: 'BF', postalCodeRequired: false},
  {name: 'Burundi', code: 'BI', postalCodeRequired: false},
  {name: 'Cambodia', code: 'KH', postalCodeRequired: false},
  {name: 'Cameroon', code: 'CM', postalCodeRequired: false},
  {name: 'Canada', code: 'CA', postalCodeRequired: true},
  {name: 'Cape Verde', code: 'CV', postalCodeRequired: false},
  {name: 'Cayman Islands', code: 'KY', postalCodeRequired: false},
  {name: 'Chad', code: 'TD', postalCodeRequired: false},
  {name: 'Chile', code: 'CL', postalCodeRequired: false},
  {name: 'China', code: 'C2', postalCodeRequired: true},
  {name: 'Colombia', code: 'CO', postalCodeRequired: false},
  {name: 'Comoros', code: 'KM', postalCodeRequired: true},
  {name: 'Congo - Brazzaville', code: 'CG', postalCodeRequired: false},
  {name: 'Congo - Kinshasa', code: 'CD', postalCodeRequired: false},
  {name: 'Cook Islands', code: 'CK', postalCodeRequired: false},
  {name: 'Costa Rica', code: 'CR', postalCodeRequired: false},
  {name: 'Côte D’ivoire', code: 'CI', postalCodeRequired: false},
  {name: 'Croatia', code: 'HR', postalCodeRequired: false},
  {name: 'Cyprus', code: 'CY', postalCodeRequired: false},
  {name: 'Czech Republic', code: 'CZ', postalCodeRequired: false},
  {name: 'Denmark', code: 'DK', postalCodeRequired: true},
  {name: 'Djibouti', code: 'DJ', postalCodeRequired: false},
  {name: 'Dominica', code: 'DM', postalCodeRequired: false},
  {name: 'Dominican Republic', code: 'DO', postalCodeRequired: false},
  {name: 'Ecuador', code: 'EC', postalCodeRequired: false},
  {name: 'Egypt', code: 'EG', postalCodeRequired: false},
  {name: 'El Salvador', code: 'SV', postalCodeRequired: false},
  {name: 'Eritrea', code: 'ER', postalCodeRequired: false},
  {name: 'Estonia', code: 'EE', postalCodeRequired: false},
  {name: 'Ethiopia', code: 'ET', postalCodeRequired: false},
  {name: 'Falkland Islands', code: 'FK', postalCodeRequired: true},
  {name: 'Faroe Islands', code: 'FO', postalCodeRequired: true},
  {name: 'Fiji', code: 'FJ', postalCodeRequired: false},
  {name: 'Finland', code: 'FI', postalCodeRequired: false},
  {name: 'France', code: 'FR', postalCodeRequired: true},
  {name: 'French Guiana', code: 'GF', postalCodeRequired: false},
  {name: 'French Polynesia', code: 'PF', postalCodeRequired: false},
  {name: 'Gabon', code: 'GA', postalCodeRequired: false},
  {name: 'Gambia', code: 'GM', postalCodeRequired: true},
  {name: 'Georgia', code: 'GE', postalCodeRequired: false},
  {name: 'Germany', code: 'DE', postalCodeRequired: true},
  {name: 'Gibraltar', code: 'GI', postalCodeRequired: false},
  {name: 'Greece', code: 'GR', postalCodeRequired: false},
  {name: 'Greenland', code: 'GL', postalCodeRequired: true},
  {name: 'Grenada', code: 'GD', postalCodeRequired: false},
  {name: 'Guadeloupe', code: 'GP', postalCodeRequired: false},
  {name: 'Guatemala', code: 'GT', postalCodeRequired: false},
  {name: 'Guinea', code: 'GN', postalCodeRequired: false},
  {name: 'Guinea-bissau', code: 'GW', postalCodeRequired: false},
  {name: 'Guyana', code: 'GY', postalCodeRequired: false},
  {name: 'Honduras', code: 'HN', postalCodeRequired: false},
  {name: 'Hong Kong Sar China', code: 'HK', postalCodeRequired: false},
  {name: 'Hungary', code: 'HU', postalCodeRequired: false},
  {name: 'Iceland', code: 'IS', postalCodeRequired: false},
  {name: 'India', code: 'IN', postalCodeRequired: false},
  {name: 'Indonesia', code: 'ID', postalCodeRequired: false},
  {name: 'Ireland', code: 'IE', postalCodeRequired: false},
  {name: 'Israel', code: 'IL', postalCodeRequired: false},
  {name: 'Italy', code: 'IT', postalCodeRequired: true},
  {name: 'Jamaica', code: 'JM', postalCodeRequired: false},
  {name: 'Japan', code: 'JP', postalCodeRequired: true},
  {name: 'Jordan', code: 'JO', postalCodeRequired: false},
  {name: 'Kazakhstan', code: 'KZ', postalCodeRequired: false},
  {name: 'Kenya', code: 'KE', postalCodeRequired: false},
  {name: 'Kiribati', code: 'KI', postalCodeRequired: true},
  {name: 'Kuwait', code: 'KW', postalCodeRequired: false},
  {name: 'Kyrgyzstan', code: 'KG', postalCodeRequired: true},
  {name: 'Laos', code: 'LA', postalCodeRequired: false},
  {name: 'Latvia', code: 'LV', postalCodeRequired: false},
  {name: 'Lesotho', code: 'LS', postalCodeRequired: false},
  {name: 'Liechtenstein', code: 'LI', postalCodeRequired: false},
  {name: 'Lithuania', code: 'LT', postalCodeRequired: false},
  {name: 'Luxembourg', code: 'LU', postalCodeRequired: false},
  {name: 'Macedonia', code: 'MK', postalCodeRequired: false},
  {name: 'Madagascar', code: 'MG', postalCodeRequired: false},
  {name: 'Malawi', code: 'MW', postalCodeRequired: true},
  {name: 'Malaysia', code: 'MY', postalCodeRequired: false},
  {name: 'Maldives', code: 'MV', postalCodeRequired: false},
  {name: 'Mali', code: 'ML', postalCodeRequired: false},
  {name: 'Malta', code: 'MT', postalCodeRequired: false},
  {name: 'Marshall Islands', code: 'MH', postalCodeRequired: false},
  {name: 'Martinique', code: 'MQ', postalCodeRequired: false},
  {name: 'Mauritania', code: 'MR', postalCodeRequired: true},
  {name: 'Mauritius', code: 'MU', postalCodeRequired: false},
  {name: 'Mayotte', code: 'YT', postalCodeRequired: true},
  {name: 'Mexico', code: 'MX', postalCodeRequired: true},
  {name: 'Micronesia', code: 'FM', postalCodeRequired: false},
  {name: 'Moldova', code: 'MD', postalCodeRequired: false},
  {name: 'Monaco', code: 'MC', postalCodeRequired: false},
  {name: 'Mongolia', code: 'MN', postalCodeRequired: false},
  {name: 'Montenegro', code: 'ME', postalCodeRequired: false},
  {name: 'Montserrat', code: 'MS', postalCodeRequired: false},
  {name: 'Morocco', code: 'MA', postalCodeRequired: false},
  {name: 'Mozambique', code: 'MZ', postalCodeRequired: false},
  {name: 'Namibia', code: 'NA', postalCodeRequired: false},
  {name: 'Nauru', code: 'NR', postalCodeRequired: true},
  {name: 'Nepal', code: 'NP', postalCodeRequired: false},
  {name: 'Netherlands', code: 'NL', postalCodeRequired: true},
  {name: 'New Caledonia', code: 'NC', postalCodeRequired: false},
  {name: 'New Zealand', code: 'NZ', postalCodeRequired: false},
  {name: 'Nicaragua', code: 'NI', postalCodeRequired: false},
  {name: 'Niger', code: 'NE', postalCodeRequired: true},
  {name: 'Nigeria', code: 'NG', postalCodeRequired: false},
  {name: 'Niue', code: 'NU', postalCodeRequired: true},
  {name: 'Norfolk Island', code: 'NF', postalCodeRequired: true},
  {name: 'Norway', code: 'NO', postalCodeRequired: true},
  {name: 'Oman', code: 'OM', postalCodeRequired: false},
  {name: 'Palau', code: 'PW', postalCodeRequired: false},
  {name: 'Panama', code: 'PA', postalCodeRequired: false},
  {name: 'Papua New Guinea', code: 'PG', postalCodeRequired: false},
  {name: 'Paraguay', code: 'PY', postalCodeRequired: false},
  {name: 'Peru', code: 'PE', postalCodeRequired: false},
  {name: 'Philippines', code: 'PH', postalCodeRequired: false},
  {name: 'Pitcairn Islands', code: 'PN', postalCodeRequired: true},
  {name: 'Poland', code: 'PL', postalCodeRequired: true},
  {name: 'Portugal', code: 'PT', postalCodeRequired: false},
  {name: 'Qatar', code: 'QA', postalCodeRequired: false},
  {name: 'Réunion', code: 'RE', postalCodeRequired: false},
  {name: 'Romania', code: 'RO', postalCodeRequired: false},
  {name: 'Russion', code: 'RU', postalCodeRequired: true},
  {name: 'Rwanda', code: 'RW', postalCodeRequired: false},
  {name: 'Samoa', code: 'WS', postalCodeRequired: false},
  {name: 'San Marino', code: 'SM', postalCodeRequired: false},
  {name: 'São Tomé and Príncipe', code: 'ST', postalCodeRequired: false},
  {name: 'Saudi Arabia', code: 'SA', postalCodeRequired: false},
  {name: 'Senegal', code: 'SN', postalCodeRequired: false},
  {name: 'Serbia', code: 'RS', postalCodeRequired: false},
  {name: 'Seychelles', code: 'SC', postalCodeRequired: false},
  {name: 'Sierra Leone', code: 'SL', postalCodeRequired: false},
  {name: 'Singapore', code: 'SG', postalCodeRequired: true},
  {name: 'Slovakia', code: 'SK', postalCodeRequired: false},
  {name: 'Slovenia', code: 'SI', postalCodeRequired: false},
  {name: 'Solomon Islands', code: 'SB', postalCodeRequired: false},
  {name: 'Somalia', code: 'SO', postalCodeRequired: false},
  {name: 'South Africa', code: 'ZA', postalCodeRequired: false},
  {name: 'South Korea', code: 'KR', postalCodeRequired: false},
  {name: 'Spain', code: 'ES', postalCodeRequired: true},
  {name: 'Sri Lanka', code: 'LK', postalCodeRequired: false},
  {name: 'St. Helena', code: 'SH', postalCodeRequired: true},
  {name: 'St. Kitts and Nevis', code: 'KN', postalCodeRequired: false},
  {name: 'St. Lucia', code: 'LC', postalCodeRequired: false},
  {name: 'St. Pierre and Miquelon', code: 'PM', postalCodeRequired: true},
  {
    name: 'St. Vincent and Grenadines',
    code: 'VC',
    postalCodeRequired: false,
  },
  {name: 'Suriname', code: 'SR', postalCodeRequired: true},
  {name: 'Svalbard and Jan Mayen', code: 'SJ', postalCodeRequired: true},
  {name: 'Swaziland', code: 'SZ', postalCodeRequired: false},
  {name: 'Sweden', code: 'SE', postalCodeRequired: true},
  {name: 'Switzerland', code: 'CH', postalCodeRequired: true},
  {name: 'Taiwan', code: 'TW', postalCodeRequired: false},
  {name: 'Tajikistan', code: 'TJ', postalCodeRequired: false},
  {name: 'Tanzania', code: 'TZ', postalCodeRequired: false},
  {name: 'Thailand', code: 'TH', postalCodeRequired: false},
  {name: 'Togo', code: 'TG', postalCodeRequired: false},
  {name: 'Tonga', code: 'TO', postalCodeRequired: false},
  {name: 'Trinidad and Tobago', code: 'TT', postalCodeRequired: false},
  {name: 'Tunisia', code: 'TN', postalCodeRequired: false},
  {name: 'Turkmenistan', code: 'TM', postalCodeRequired: false},
  {name: 'Turks and Caicos Islands', code: 'TC', postalCodeRequired: false},
  {name: 'Tuvalu', code: 'TV', postalCodeRequired: true},
  {name: 'Uganda', code: 'UG', postalCodeRequired: false},
  {name: 'Ukraine', code: 'UA', postalCodeRequired: false},
  {name: 'United Arab Emirates', code: 'AE', postalCodeRequired: false},
  {name: 'United Kingdom', code: 'GB', postalCodeRequired: true},
  {name: 'United States', code: 'US', postalCodeRequired: true},
  {name: 'Uruguay', code: 'UY', postalCodeRequired: false},
  {name: 'Vanuatu', code: 'VU', postalCodeRequired: false},
  {name: 'Vatican City', code: 'VA', postalCodeRequired: true},
  {name: 'Venezuela', code: 'VE', postalCodeRequired: false},
  {name: 'Vietnam', code: 'VN', postalCodeRequired: false},
  {name: 'Wallis and Futuna', code: 'WF', postalCodeRequired: true},
  {name: 'Yemen', code: 'YE', postalCodeRequired: false},
  {name: 'Zambia', code: 'ZM', postalCodeRequired: false},
  {name: 'Zimbabwe', code: 'ZW', postalCodeRequired: false},
];

// list of country codes extracted from STRIPE_SUPPORTED_COUNTRIES
const STRIPE_COUNTRY_LIST = STRIPE_SUPPORTED_COUNTRIES.map(function (country) {
  return country.code;
});

// list of country codes extracted from paypalSupportedCountries
const PAYPAL_COUNTRY_LIST = PAYPAL_SUPPORTED_COUNTRIES.map(function (country) {
  return country.code === 'C2' ? 'CN' : country.code;
});

const COMBINED_COUNTRY_LIST = STRIPE_COUNTRY_LIST.concat(PAYPAL_COUNTRY_LIST);
// list of country codes supported by available payment gateways (currently PayPal and Stripe)
const COMMERCE_SUPPORTED_COUNTRY_LIST = COMBINED_COUNTRY_LIST.filter(
  function (countryCode, i) {
    return COMBINED_COUNTRY_LIST.indexOf(countryCode) === i;
  }
);

// selects country data from commerceCountryList based on COMMERCE_SUPPORTED_COUNTRY_LIST
export const commerceSupportedCountryList: Array<CommerceCountry> =
  COMMERCE_SUPPORTED_COUNTRY_LIST.reduce<Array<any>>(function (acc, cur) {
    commerceCountryList.forEach(function (country) {
      if (country.code === cur) {
        acc.push(country);
      }
    });
    return acc;
  }, []);

function createMap(strings: Array<string>): {
  [key: string]: boolean;
} {
  return strings.reduce<Record<string, any>>(function (acc, cur) {
    acc[cur] = true;
    return acc;
  }, {});
}

// used to determine if a country is supported by at least one availble payment provider
export const commerceSupportedCountryCodes = createMap(
  COMMERCE_SUPPORTED_COUNTRY_LIST
);

// used to determine Stripe support for a country
export const stripeCountryCodes = createMap(STRIPE_COUNTRY_LIST);

// used to determine PayPal support for a country
export const paypalCountryCodes = createMap(PAYPAL_COUNTRY_LIST);
